exports = module.exports = require("./../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".tooltip-disappear{\n\tdisplay:none !important;\n}\n.tooltip-wrapper{\n\tposition: absolute;\n    pointer-events: none;\n}\n.tooltip-wrapper:before {\n    position: absolute;\n    z-index: 1000001;\n    display: inline-block;\n    width: 0;\n    height: 0;\n    color: rgba(0,0,0,0.8);\n    pointer-events: none;\n    content: \"\";\n    border: 5px solid transparent;\n    right: 50%;\n    top: -8px;\n    margin-right: -5px;\n    border-top-color: rgba(0,0,0,0.8);\n}\n.tooltip-wrapper:after{\n\tdisplay: inline-block;\n\tposition: absolute;\n    z-index: 1000000;\n    padding: 5px 8px;\n    font: normal normal 11px/1.5 'microsoft yahei';\n    color: #fff;\n    text-align: center;\n    text-decoration: none;\n    text-shadow: none;\n    text-transform: none;\n    letter-spacing: normal;\n    word-wrap: break-word;\n    white-space: pre;\n    pointer-events: none;\n    content: attr(aria-label);\n    background: rgba(0,0,0,0.8);\n    border-radius: 3px;\n    -webkit-font-smoothing: subpixel-antialiased;\n    transform: translate(50%, -100%);\n    top: -8px;\n    right: 50%;\n}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ../~/css-loader!../src/Tooltip/react.tooltip.css
 ** module id = 285
 ** module chunks = 0
 **/